var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"me-avatar"},[_c('div',{staticClass:"wrapper"},[_c('img',{attrs:{"src":_vm.user.avatar}})]),_c('div',{staticClass:"copy"},[_c('div',{staticClass:"nickname"},[_vm._v(_vm._s(_vm.user.nickname))]),_c('div',{staticClass:"member"},[_c('member',{attrs:{"grade":_vm.user.grade}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }